export const getAriaLive = (state) => state.ariaLive;
